export default "__VITE_PUBLIC_ASSET__67956ca5__"